/**
 * Whose survey work is on this device (ADR-0021). A sign-out keeps unsent work
 * so it is never lost; until its owner signs in again and it is sent, nobody
 * else may use the device — they would see that person's surveys and photos,
 * and the outbox would send them under the wrong account.
 */
const KEY = 'sss.device.owner';

export interface DeviceOwner {
  id: string;
  email: string;
}

export function deviceOwner(): DeviceOwner | null {
  try {
    const v = localStorage.getItem(KEY);
    return v ? (JSON.parse(v) as DeviceOwner) : null;
  } catch {
    return null;
  }
}

export function setDeviceOwner(user: DeviceOwner): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ id: user.id, email: user.email }));
  } catch {
    /* storage unavailable: the check below simply can't run */
  }
}

export function clearDeviceOwner(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}

/** Another person's unsent work is waiting on this device. */
export function heldByAnotherUser(owner: DeviceOwner | null, userId: string, unsentItems: number): boolean {
  return !!owner && owner.id !== userId && unsentItems > 0;
}
